/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var ThemeResolver = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ThemeResolver, _super);
    function ThemeResolver() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ThemeResolver.e = function (a, b, c) {
        if (a == 1) {
            return c;
        }
        return b;
    };
    ThemeResolver.c = function (a, b, c) {
        if (a == 1) {
            return c;
        }
        return b;
    };
    ThemeResolver.b = function (a, b, c) {
        if (a == 1) {
            return c;
        }
        return b;
    };
    ThemeResolver.d = function (a, b, c) {
        if (a == 1) {
            return c;
        }
        return b;
    };
    ThemeResolver.f = function (a, b, c) {
        if (a == 1) {
            return c;
        }
        return b;
    };
    ThemeResolver.a = function (a, b, c) {
        if (a == 1) {
            return c;
        }
        return b;
    };
    ThemeResolver.$t = markType(ThemeResolver, 'ThemeResolver');
    return ThemeResolver;
}(Base));
export { ThemeResolver };
//# sourceMappingURL=ThemeResolver.js.map
